import { apiGet, apiPost, apiPut, apiDelete } from "./client.js";

export const listTenants = (orgId) => apiGet(`/api/v1/orgs/${orgId}/tenants`).then((d) => d.tenants || []);
export const getTenant = (orgId, id) => apiGet(`/api/v1/orgs/${orgId}/tenants/${id}`);
export const createTenant = (orgId, data) => apiPost(`/api/v1/orgs/${orgId}/tenants`, data);
export const updateTenant = (orgId, id, data) => apiPut(`/api/v1/orgs/${orgId}/tenants/${id}`, data);
export const deleteTenant = (orgId, id) => apiDelete(`/api/v1/orgs/${orgId}/tenants/${id}`);
